import React from "react";

// Slack-style inline mention token stored in post/comment text: @[Name](token).
// "token" is the mentioned member's public url_token (member_token in the API).
export const MENTION_RE = /@\[([^\]]+)\]\(([^)\s]+)\)/g;

// Turn display text (plain "@Name") + the picked mentions into tokenized text for
// submission. Replaces the first still-plain "@Name" for each picked mention.
export function serializeMentions(text, mentions) {
  let out = String(text || "");
  (mentions || []).forEach((m) => {
    if (!m || !m.name || !m.token) return;
    const plain = `@${m.name}`;
    const idx = out.indexOf(plain);
    if (idx === -1) return; // the member was un-typed after picking — skip
    out = out.slice(0, idx) + `@[${m.name}](${m.token})` + out.slice(idx + plain.length);
  });
  return out;
}

// Strip mention tokens back to plain "@Name" (for previews / plain-text contexts).
export function stripMentions(text) {
  return String(text || "").replace(MENTION_RE, "@$1");
}

// Render text with mention tokens as React nodes — mentions become a coloured,
// bold "@Name". Everything else is returned as-is (plain strings).
export function renderMentions(text, primary = "#16a34a") {
  const src = String(text || "");
  if (!src.includes("@[")) return src;
  const nodes = [];
  const re = new RegExp(MENTION_RE.source, "g");
  let last = 0;
  let match;
  let key = 0;
  while ((match = re.exec(src)) !== null) {
    if (match.index > last) nodes.push(src.slice(last, match.index));
    nodes.push(
      <span key={`m${key++}`} className="font-semibold" style={{ color: primary }}>
        @{match[1]}
      </span>
    );
    last = match.index + match[0].length;
  }
  if (last < src.length) nodes.push(src.slice(last));
  return nodes;
}
